import { FormGroup } from "@angular/forms";
var FacilitySelectorComponent = /** @class */ (function () {
    function FacilitySelectorComponent() {
        this.facilityTypes = [];
        this.filteredFacilities = [];
    }
    Object.defineProperty(FacilitySelectorComponent.prototype, "facilities", {
        set: function (value) {
            var _this = this;
            this.filteredFacilities = value.filter((function (t) { return t.facilityTypeId === _this.facilityType.value; }));
            this._facilities = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FacilitySelectorComponent.prototype, "facilityType", {
        get: function () { return this.facilitySelectionGroup.get('facilityType'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FacilitySelectorComponent.prototype, "facility", {
        get: function () { return this.facilitySelectionGroup.get('facility'); },
        enumerable: true,
        configurable: true
    });
    FacilitySelectorComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.facilityType
            .valueChanges
            .subscribe(function (value) {
            _this.filteredFacilities = _this._facilities.filter((function (t) { return t.facilityTypeId === value; }));
            if (value === -1) {
                _this.facility.patchValue(null);
            }
        });
    };
    return FacilitySelectorComponent;
}());
export { FacilitySelectorComponent };



// WEBPACK FOOTER //
// F:/PHAZP5152IS01-4/_work/202/s/src/app/view-request/request-planning-modal/facility-selector/facility-selector.component.ts.pre-build-optimizer.js